import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Row } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import Image from '../../../shared/components/Image';
import VerbDropdownMenu from '../../../shared/components/VerbDropdownMenu';
import { IMAGE_PROPS } from '../../../shared/utils/ImageUtils';
import { SEGMENT_EVENTS } from '../../../shared/Constants';

const CollectionCard = (props) => {
    const {
        segmentEventHandler,
        className,
        isReadOnly,
        collection,
        collection: { _id, name, thumbnailImageUrl, subtitle },
        isSlide,
        hideMetadata = false,
        disableSubtitle,
        disableLabel,
        overlayProps,
        cardImageProps,
        textProp,
        menuOptions,
        customStyles,
        userCompany,
        isVerbAdmin,
        history,
        customLink,
        cardNumber,
        fromExplore = false,
        pathsContext,
        isCollInterstitial = false,
        headerClassName = '',
    } = props;

    const [subtitleHeight, setSubtitleHeight] = useState('80px');
    const [subtitleLines, setSubtitleLines] = useState(3);

    useEffect(() => {
        if (fromExplore) {
            const collectionTitle = document.querySelector(`.collection-card-title-${cardNumber}`);
            const collectionTitleHeight = collectionTitle?.offsetHeight || 0;

            const collectionImage = document.querySelector(
                `.collection-asset-left-display-${cardNumber} .trackCardImage`
            );
            const collectionImageHeight = collectionImage?.clientHeight || 177;

            const collectionSubtitle = document.querySelector(`.collection-card-subtitle-${cardNumber}`);
            const collectionSubtitleLineHeight = collectionSubtitle
                ? parseInt(window.getComputedStyle(collectionSubtitle, null).getPropertyValue('line-height'), 10)
                : 1;

            const behaviorsPosition = collectionImageHeight - 28 - collectionTitleHeight - 28 - 15;

            setSubtitleHeight(behaviorsPosition);
            setSubtitleLines(Math.round(behaviorsPosition / collectionSubtitleLineHeight));
        }
    }, []);

    const _getCollectionTypeDisplay = () => {
        if (collection.type === 'STANDARD') {
            return { text: 'CERTIFIED COLLECTION', headingClass: 'certified' };
        }
        return { text: 'COLLECTION', headingClass: '' };
    };

    const _cardContainerClickHandler = () => {
        if (segmentEventHandler) {
            segmentEventHandler();
        }

        return history.push(customLink || `/collection/${collection.permalink || collection._id}`);
    };

    const imageProps = cardImageProps || IMAGE_PROPS.collectionImageCloudinary;

    let contentCount = null;
    if (collection.contentIds || collection.contentLength) {
        const contentLength = collection.contentLength || (collection.contentIds && collection.contentIds.length) || 0;
        contentCount = <h6 className={'asset-category-display asset-primary-behavior'}>{contentLength} ACTIVITIES</h6>;
    }

    const { text, headingClass } = _getCollectionTypeDisplay();

    const cardWithOutLink = (
        <Row key={_id} className={'collection-container'}>
            <div className={`${isCollInterstitial ? '' : 'col-5'} asset-left-display collection-asset-left-display-${cardNumber}`}>
                <Image
                    overlay={overlayProps}
                    src={thumbnailImageUrl}
                    dimension={imageProps.dimension}
                    cloudinaryCrop={imageProps.cloudinaryCrop}
                    textProp={textProp}
                    className={'trackCardImage'}
                />
            </div>
            <div className={`${isCollInterstitial ? 'col' : 'col-7'} collection-details`}>
                <div className={'row'}>
                    { !isCollInterstitial && (
                        <h6 className={cns('collection-type col-12', headingClass)} hidden={disableLabel}>
                            {text}
                        </h6>
                    )}
                    <h4 className={cns(`collection-title collection-card-title-${cardNumber} col-12 ${headerClassName}`)}>{name}</h4>
                    {!disableSubtitle && (
                        <small
                            className={`col-12 collection-subtitle collection-card-subtitle-${cardNumber} ${isCollInterstitial ? '' : 'hidden-xs hidden-sm hidden-md'}`}
                        >
                            {subtitle}
                        </small>
                    )}
                    <div className={cns('collection-metadata-container', 'collection-behaviors')} hidden={hideMetadata}>
                        {contentCount}
                    </div>
                </div>
            </div>
        </Row>
    );

    return (
        <div
            className={cns(className, `collection-card collection-card-${cardNumber}`, {
                'col-sm-12 col-md-12': isSlide,
                disabled: isReadOnly
            })}
            style={customStyles}
        >
            {menuOptions && (
                <VerbDropdownMenu dropdownData={menuOptions}>
                    <i className={'menu-icon fal fa-fw fa-ellipsis-h'} />
                </VerbDropdownMenu>
            )}
            <div onClick={!isReadOnly ? () => _cardContainerClickHandler() : undefined}>{cardWithOutLink}</div>
        </div>
    );
};

CollectionCard.propTypes = {
    segmentEventHandler: PropTypes.func,
    cardImageProps: PropTypes.object,
    className: PropTypes.string,
    collection: PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
        category: PropTypes.string,
        thumbnailImageUrl: PropTypes.string,
        subtitle: PropTypes.string,
        behaviors: PropTypes.array,
        recommendationInfo: PropTypes.object,
        type: PropTypes.string,
        isFeatured: PropTypes.bool,
        contentIds: PropTypes.array,
        contentLength: PropTypes.number,
        permalink: PropTypes.string
    }),
    customLink: PropTypes.string,
    customStyles: PropTypes.object,
    disableLabel: PropTypes.bool,
    disableSubtitle: PropTypes.bool,
    hideMetadata: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    isSlide: PropTypes.bool,
    isVerbAdmin: PropTypes.bool,
    overlayProps: PropTypes.object,
    textProp: PropTypes.object,
    userCompany: PropTypes.object,
    history: PropTypes.object,
    menuOptions: PropTypes.array,
    cardNumber: PropTypes.number,
    fromExplore: PropTypes.bool,
    pathsContext: PropTypes.object,
    isCollInterstitial: PropTypes.bool,
};

export const CollectionCardComponent = CollectionCard;

export default withRouter(CollectionCard);
